import { Injectable } from '@angular/core';
import { AuthRedirectDebugService } from '../auth-redirect-debug.service';
import { AuthRedirectReason } from '../auth-redirect-reason';
import { InstanceActiveService } from '../../services/instance-active.service';
import { NavigationService } from '../../services/navigation.service';
import { StorageService } from '../../services/storage.service';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { KeycloakClientService } from './keycloak-client.service';

@Injectable({
    providedIn: 'root',
})
export class AuthLogoutService {
    constructor(
        private keycloakClient: KeycloakClientService,
        private storageService: StorageService,
        private navigationService: NavigationService,
        private instanceActiveService: InstanceActiveService,
        private notificationService: NotificationsService,
        private authRedirectDebug: AuthRedirectDebugService
    ) {}

    async performLogout(redirectUri: string, triggerReason: AuthRedirectReason | string = 'unknown'): Promise<void> {
        this.authRedirectDebug.log(AuthRedirectReason.LogoutComponent, {
            triggerReason,
        });

        this.storageService.clear();
        this.navigationService.clearCache();
        this.instanceActiveService.clear();
        this.notificationService.destroy();

        await this.keycloakClient.logout(redirectUri);
    }

    getApplicationBaseUrl(): string {
        let url = location.protocol + '//' + location.host;
        if (location.port) {
            url = url + ':' + location.port;
        }
        return url;
    }
}
